import { brandsI18n } from '../../localization'
import { getTimeRemaining } from '../../utils/time'

export function getPendingTimeAlert(
  expiryTimeEpochInMillis?: number,
  kycType?: 'STPK' | 'STPT',
  isC1IdAvailable?: boolean
) {
  if (!expiryTimeEpochInMillis) {
    return
  }

  const pendingTime = getTimeRemaining(expiryTimeEpochInMillis)

  const isExpired = pendingTime === false
  let pendingTimeText = ''

  if (pendingTime === false) {
    if (kycType === 'STPK') {
      if (isC1IdAvailable) {
        pendingTimeText = brandsI18n.t('axis.note.kycWindowExpiredSTPKWithC1')
      } else {
        pendingTimeText = brandsI18n.t('axis.note.kycWindowExpiredSTPK')
      }
    } else if (kycType === 'STPT') {
      pendingTimeText = brandsI18n.t('axis.note.kycWindowExpiredSTPT')
    } else {
      pendingTimeText = brandsI18n.t('axis.note.kycWindowExpired')
    }
  } else if (kycType === 'STPT') {
    pendingTimeText = brandsI18n.t('axis.note.onlineKycWindowWillExpireSTPT', {
      time: pendingTime,
    })
  } else if (kycType === 'STPK') {
    pendingTimeText = brandsI18n.t('axis.note.onlineKycWindowWillExpireSTPK', {
      time: pendingTime,
    })
  }

  return {
    isExpired,
    pendingTimeText,
  }
}
